import api from 'service/api'

const dponetAPI = api.create('dponet')

const edit = async ({ userId = '', ...data }) => {
  return await dponetAPI.put(`/users/${userId}`, data)
}

const newPassword = async (data) => {
  return await dponetAPI.put(`/users/password`, { api_user: data })
}

const me = async () => {
  return await dponetAPI.get('/user/me')
}

const updatePassword = async (data) => {
  return await dponetAPI.post(`/users/update_password`, data)
}

const updateStep = async ({ userId, stepId, ...data }) => {
  return await dponetAPI.put(`/users/${userId}/users_steps/${stepId}`, {
    user_step: data,
  })
}

const exportArchive = async ({ ...params }) => {
  return await dponetAPI.get('/users/export', { params })
}

const users = {
  edit,
  newPassword,
  me,
  updatePassword,
  updateStep,
  exportArchive,
}

export default users
